import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=1a0b0a90"
import script from "./PaymentTable.vue?vue&type=script&lang=ts"
export * from "./PaymentTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports